import * as React from 'react';
import cx from 'classnames';

import Link from 'components/Link';
import Text, { TextSize } from 'components/Text';

import './styles/SelectBox.scss';

export default function SelectBox({
  selected,
  full,
  flush,
  label,
  disabled,
  onSelect,
  textSize,
}: {
  selected: boolean;
  full?: boolean;
  flush?: boolean;
  disabled?: boolean;
  label: string;
  onSelect: () => void;
  textSize?: TextSize;
}) {
  return (
    <Link disabled={disabled} onClick={onSelect}>
      <Text
        className={cx(
          'SelectBox',
          selected && 'SelectBox--selected',
          full && 'SelectBox--full',
          flush && 'SelectBox--flush',
          disabled && 'SelectBox--disabled'
        )}
        color="chalkboard"
        weight={selected ? 'semibold' : 'normal'}
        size={textSize ?? 'small'}>
        {label}
      </Text>
    </Link>
  );
}
